import { createElement } from "react";
import React from "react";
import * as react from "react";
import { LoadingIndicator_skeleton, Alert_errorAlert, Dialog_dialogActions, Dialog_dialogContent, Dialog_dialogTitle, Dialog_Dialog } from "../Components/Components.js";
import { uncurry2, comparePrimitives, compareArrays, defaultOf, equals, createObj } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { Interop_reactApi } from "../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { cons, empty as empty_1, singleton, ofArray } from "../fable_modules/fable-library-js.4.17.0/List.js";
import { Union } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { PreOpenContent_$reflection } from "./PreOpenSummaryTypes.js";
import { obj_type, union_type, string_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { year, month, day, now as now_1, toString, dayOfWeek, op_Subtraction, parse } from "../fable_modules/fable-library-js.4.17.0/Date.js";
import { totalDays } from "../fable_modules/fable-library-js.4.17.0/TimeSpan.js";
import { Time_monthToString, Time_dayOfWeekToString, Time_utcDateToLocalDate, Format_toPercentageChange, Format_formatSpacedNumber } from "../Components/Utils.js";
import { join, format } from "../fable_modules/fable-library-js.4.17.0/String.js";
import { concat, append as append_1, mapIndexed, sortByDescending, map, item, equalsWith } from "../fable_modules/fable-library-js.4.17.0/Array.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.17.0/Seq.js";
import { AssetBanner } from "../Components/Ads.js";
import { Feedback } from "./PreOpenSummaryFeedback.js";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.17.0/Option.js";
import { toString as toString_1 } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";

export function PreOpenSubModal(onClose) {
    let elems_3, value_5, value_6, elems_2, elems, elems_1;
    return createElement(Dialog_Dialog, {
        onClose: onClose,
        children: ofArray([Dialog_dialogTitle("Les alle \"Før børsåpning\"-oppdateringer med aksje.io+"), Dialog_dialogContent(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            maxWidth: 800,
        }], (elems_3 = [(value_5 = "\"Før børsåpning\" er vår markedsoppdatering for brukere av aksje.io som sendes ut hver handelsdag før børsen åpner. Her samler vi oppdateringer på råvarepriser, valuta og kryptovaluta, markedsutvikleringer og de siste oppdateringer fra de børsnoterte selskapene.", createElement("p", {
            children: [value_5],
        })), (value_6 = "Med aksje.io+ abonnement får du tilgang til alle oppdateringer, mens brukere som ikke er abonnementer kan lese oppdateringene hver mandag og tirsdag. Abonner på aksje.io+ gjennom vår app som du kan laste ned fra Apple App Store og Google Play Store.", createElement("p", {
            children: [value_6],
        })), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 10 + "px ",
            marginTop: 10,
        }], (elems_2 = [createElement("a", createObj(ofArray([["style", {
            lineHeight: 0 + "px",
        }], ["href", "https://apps.apple.com/app/aksje-io/id6448765436"], ["aria-label", "Last ned aksje.io fra Apple App Store"], (elems = [createElement("img", {
            src: "/images/app_store_download.svg",
            target: "_blank",
            alt: "Lenke til aksje.io på Apple App Store",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("a", createObj(ofArray([["style", {
            lineHeight: 0 + "px",
        }], ["href", "https://play.google.com/store/apps/details?id=io.aksje.app&pli=1"], ["target", "_blank"], (elems_1 = [createElement("img", {
            style: {
                height: 50,
            },
            src: "https://play.google.com/intl/en_us/badges/static/images/badges/no_badge_web_generic.png",
            alt: "Last ned fra Google Play Store",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]))))), Dialog_dialogActions(singleton(createElement("button", {
            className: "pill-button-small",
            onClick: (_arg) => {
                onClose();
            },
            children: "Lukk",
        })))]),
    });
}

class PreOpenStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Loading", "Success", "RequireSub", "FetchError", "NotFound"];
    }
}

function PreOpenStatus_$reflection() {
    return union_type("Investfora.PreOpenSummary.PreOpenStatus", [], PreOpenStatus, () => [[], [["Item", PreOpenContent_$reflection()]], [], [["Item", string_type]], []]);
}

function section(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            maxWidth: 800,
            backgroundColor: "#FFFFFF",
            padding: 2 + "vw",
            border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
            borderRadius: 5,
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function sectionTitle(x) {
    return createElement("h3", {
        style: {
            fontSize: 1.5 + "rem",
            fontWeight: 500,
        },
        children: x,
    });
}

export function dayOfWeekToString(x) {
    switch (x) {
        case 0:
            return "Søndag";
        case 1:
            return "Mandag";
        case 2:
            return "Tirsdag";
        case 3:
            return "Onsdag";
        case 4:
            return "Torsdag";
        case 5:
            return "Fredag";
        case 6:
            return "Lørdag";
        default:
            return "";
    }
}

function since(date, prev) {
    try {
        const currentDate = parse(date);
        const prevDate = parse(prev);
        return (totalDays(op_Subtraction(currentDate, prevDate)) < 2) ? "Siden børsen stengte i går" : (`Siden børsen stengte ${dayOfWeekToString(dayOfWeek(prevDate)).toLocaleLowerCase()}`);
    }
    catch (matchValue) {
        return `Siden $${prev}`;
    }
}

export function sinceDay(date, prev) {
    try {
        const currentDate = parse(date);
        const prevDate = parse(prev);
        return (totalDays(op_Subtraction(currentDate, prevDate)) < 2) ? "i går" : dayOfWeekToString(dayOfWeek(prevDate)).toLocaleLowerCase();
    }
    catch (matchValue) {
        return prev;
    }
}

function upDown(prev, current) {
    if (current === prev) {
        return "uendret";
    }
    else if (current > prev) {
        return "opp";
    }
    else {
        return "ned";
    }
}

function priceDiff(current, previous) {
    let d_1;
    const d = current - previous;
    d_1 = ((d < 0) ? (d * -1) : d);
    if (d_1 > 1000) {
        return Format_formatSpacedNumber(~~d_1);
    }
    else {
        return format('{0:' + "0.00" + '}', d_1);
    }
}

function formatCurrency(c) {
    if (c > 1000) {
        return Format_formatSpacedNumber(~~c);
    }
    else {
        return format('{0:' + "0.00" + '}', c);
    }
}

function abbrPercentage(current, previous) {
    const pctChange = Format_toPercentageChange(current, previous);
    return (((pctChange > 0) ? "+" : "") + format('{0:' + "0.00" + '}', pctChange)) + "%";
}

function phraseDividends(x) {
    if (!equalsWith(equals, x, defaultOf()) && (x.length === 0)) {
        return "";
    }
    else if (!equalsWith(equals, x, defaultOf()) && (x.length === 1)) {
        const y_3 = item(0, x);
        return `I dag er siste mulighet til å handle ${y_3.Asset} inklusivt utbytte på ${y_3.Currency}${formatCurrency(y_3.Amount)}. Aksjen handles ex. utbytte fra og med ${Time_utcDateToLocalDate(y_3.ExDate)}.`;
    }
    else if (!equalsWith(equals, x, defaultOf()) && (x.length === 2)) {
        const z = item(1, x);
        const y_4 = item(0, x);
        return `I dag er siste mulighet for å handle ${y_4.Asset} og ${z.Asset} inklusivt utbytte på henholdsvis ${y_4.Currency}${formatCurrency(y_4.Amount)} og ${z.Currency}${formatCurrency(z.Amount)}. Aksjene handles ex. utbytte fra og med ${Time_utcDateToLocalDate(y_4.ExDate)}`;
    }
    else {
        return `I dag er siste mulighet for å handle følgende aksjer inklusivt utbytter: ${join("", map((z_1) => (`${z_1.Asset} handles inklusivt utbytte på ${z_1.Currency}${formatCurrency(z_1.Amount)}. `), x))}`;
    }
}

function countryCodeToEmoji(cc) {
    switch (cc) {
        case "US":
            return "🇺🇸";
        case "NO":
            return "🇳🇴";
        case "DK":
            return "🇩🇰";
        case "SE":
            return "🇸🇪";
        case "JP":
            return "🇯🇵";
        case "CN":
            return "🇨🇳";
        case "KR":
            return "🇰🇷";
        case "DE":
            return "🇩🇪";
        case "FI":
            return "🇫🇮";
        default:
            return "";
    }
}

function phraseIndexes(latestTradingDay, x) {
    let array_6;
    const usOnly = !x.some((y) => (y.CountryCode !== "US"));
    const allNegative = !x.some((y_1) => (y_1.Latest.Quote > y_1.Previous.Quote));
    const allPositive = !x.some((y_2) => (y_2.Latest.Quote < y_2.Previous.Quote));
    const development = allNegative ? (!x.some((y_3) => (Format_toPercentageChange(y_3.Previous.Quote, y_3.Latest.Quote) > -1)) ? (usOnly ? "Kraftig nedtur på de amerikanske børsene" : "Kraftige fall på tvers av børsene") : (usOnly ? "Nedgang på de amerikanske børsene" : "Nedgang på på tvers av børsene")) : (allPositive ? (!x.some((y_4) => (Format_toPercentageChange(y_4.Previous.Quote, y_4.Latest.Quote) < 1)) ? (usOnly ? "Kraftig oppgang på de amerikanske børsene" : "Kraftig oppgang på tvers av børsene") : (usOnly ? "Oppgang på de amerikanske børsene" : "Oppgang på tvers av børsene")) : (usOnly ? "Blandet utvikling på de amerikanske børsene" : "Blandet utvikling på børsene"));
    const USAllTimeHigh = !((array_6 = x.filter((y_5) => (y_5.CountryCode === "US")), array_6.some((y_6) => (y_6.AllTimeHigh === false))));
    const now = toString(now_1(), "yyyy-MM-dd");
    return join("", toList(delay(() => append(singleton_1(`${development} ${sinceDay(now, latestTradingDay)}. `), delay(() => (USAllTimeHigh ? singleton_1("De amerikanske indeksene avsluttet alle dagen på all-time high nivåer. ") : empty()))))));
}

function paragraphHolder(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            margin: ((20 + "px ") + 0) + "px",
            gap: 5 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function paragraphTitle(title) {
    return createElement("h3", {
        style: {
            fontWeight: "bold",
            margin: 0,
        },
        children: title,
    });
}

function paragraphText(txt) {
    return createElement("p", {
        style: {
            margin: 0,
        },
        children: txt,
    });
}

function tickerChip(ticker, market) {
    return createElement("a", {
        style: {
            border: (((1 + "px ") + "solid") + " ") + "var(--text-main)",
            borderRadius: 25,
            padding: ((5 + "px ") + 10) + "px",
            textAlign: "center",
            fontSize: 0.865 + "rem",
        },
        href: `/stock/${market}/${ticker}`,
        children: `${ticker}.${market}`,
    });
}

function drawIndexes(latestTradingDay, indexDesc, indexes) {
    let elems_6, elems_5;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1,
    }], (elems_6 = [createElement("p", {
        children: [(indexDesc == null) ? phraseIndexes(latestTradingDay, indexes) : indexDesc],
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1,
        gap: 10 + "px ",
    }], (elems_5 = map((i_1) => {
        let elems_4, elems, elems_3, elems_2;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10 + "px ",
            backgroundColor: "var(--bg-main)",
            padding: 5,
            borderRadius: 5,
            flexGrow: 1,
        }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }], (elems = [createElement("span", {
            style: {
                fontSize: 30 + "px",
            },
            children: countryCodeToEmoji(i_1.CountryCode),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        }], (elems_3 = [createElement("span", {
            style: {
                fontWeight: "bold",
                color: "var(--text-main)",
            },
            children: i_1.Name,
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 20 + "px ",
        }], (elems_2 = toList(delay(() => {
            let elems_1;
            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 15 + "px ",
            }], (elems_1 = [createElement("span", {
                style: {
                    color: (i_1.Latest.Quote > i_1.Previous.Quote) ? "green" : ((i_1.Latest.Quote < i_1.Previous.Quote) ? "var(--sell)" : "#fff"),
                },
                children: `${abbrPercentage(i_1.Latest.Quote, i_1.Previous.Quote)}`,
            }), createElement("span", {
                style: {
                    color: "var(--text-dim)",
                },
                children: `${i_1.Latest.Quote}`,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (i_1.AllTimeHigh ? singleton_1(createElement("span", {
                style: {
                    color: "var(--text-main)",
                },
                children: "🏆 All-time high!",
            })) : empty())));
        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
    }, sortByDescending((i) => [i.Ticker === "SP500", i.Ticker === "NASDAQCOM"], indexes, {
        Compare: compareArrays,
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
}

function drawMarketChanges(latestTradingDay, market) {
    let elems, children_2;
    let desc;
    try {
        const prevDate = parse(latestTradingDay);
        desc = ((totalDays(op_Subtraction(now_1(), prevDate)) < 2) ? "Gårdagens " : (`${dayOfWeekToString(dayOfWeek(prevDate))}ens `));
    }
    catch (matchValue) {
        desc = "";
    }
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        margin: ((15 + "px ") + 0) + "px",
    }], (elems = [(children_2 = toList(delay(() => append(singleton_1(createElement("span", {
        children: [`${desc}vinnere og tapere på `],
    })), delay(() => append(singleton_1(createElement("a", {
        style: {},
        href: `/market/${market.Ticker}`,
        children: `${market.Name}: `,
    })), delay(() => mapIndexed((i, c) => {
        let copyOfStruct_1;
        const diff = `${(c.Percentage > 0) ? "+" : ""}${(copyOfStruct_1 = (c.Percentage / 100), format('{0:' + "0.00" + '}', copyOfStruct_1))}`;
        const st = (i !== 0) ? ", " : "";
        const children = toList(delay(() => append((st !== "") ? singleton_1(createElement("span", {
            children: [st],
        })) : empty(), delay(() => append(singleton_1(createElement("a", {
            href: `/stock/${c.Market}/${c.Ticker}`,
            children: `${c.Ticker}`,
        })), delay(() => singleton_1(createElement("span", {
            style: {
                color: (c.Percentage < 0) ? "red" : "green",
            },
            children: ` ${diff}%`,
        }))))))));
        return createElement("span", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        });
    }, sortByDescending((m) => m.Percentage, append_1(market.Winners, market.Losers), {
        Compare: comparePrimitives,
    })))))))), createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function linkToAll() {
    let elems;
    return createElement("a", createObj(ofArray([["href", "/pre-opens"], (elems = ["Se alle publiseringer", createElement("i", {
        style: {
            marginLeft: 5,
        },
        className: "fas fa-arrow-right",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function drawPreOpen(displayUpgrade, date, x) {
    let elems_4;
    let today;
    try {
        const asDt = parse(date);
        today = (`${Time_dayOfWeekToString(dayOfWeek(asDt)).toLocaleLowerCase()} ${day(asDt)}. ${Time_monthToString(month(asDt)).toLocaleLowerCase()} ${year(asDt)}`);
    }
    catch (matchValue) {
        today = date;
    }
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_4 = toList(delay(() => append(singleton_1(section(toList(delay(() => append(singleton_1(createElement("h3", {
        style: {
            fontSize: 1.5 + "rem",
            fontWeight: 500,
            margin: 0,
            marginBottom: 20,
            borderBottom: (((2 + "px ") + "solid") + " ") + "var(--bg-normal)",
        },
        children: `Før børsåpning: ${Time_utcDateToLocalDate(date)}`,
    })), delay(() => append(singleton_1(createElement("span", {
        children: [`Du leser "Før børsåpning" for ${today}.`],
    })), delay(() => append((x.Indexes.length > 0) ? singleton_1(drawIndexes(x.LatestTradingDay, x.IndexDesc, x.Indexes)) : empty(), delay(() => {
        let drawSingle, elems;
        return append((x.Commodities.length > 0) ? ((drawSingle = ((c) => {
            const latest = format('{0:' + "0.00" + '}', c.Latest.Price);
            return createElement("span", {
                children: [` er ${c.Name} prisen ${upDown(c.Compare.Price, c.Latest.Price)} omtrent $${priceDiff(c.Latest.Price, c.Compare.Price)} til $${latest}.`],
            });
        }), singleton_1(createElement("p", createObj(ofArray([["style", {}], (elems = toList(delay(() => append(singleton_1(createElement("span", {
            children: [since(date, x.LatestTradingDay)],
        })), delay(() => {
            const matchValue_1 = x.Commodities;
            if (!equalsWith(equals, matchValue_1, defaultOf()) && (matchValue_1.length === 1)) {
                return singleton_1(drawSingle(item(0, matchValue_1)));
            }
            else {
                const c_2 = matchValue_1;
                return append(singleton_1(drawSingle(item(0, c_2))), delay(() => map((y_1) => {
                    const latest_1 = format('{0:' + "0.00" + '}', y_1.Latest.Price);
                    return createElement("span", {
                        children: [` ${y_1.Name} er ${upDown(y_1.Compare.Price, y_1.Latest.Price)} omtrent $${priceDiff(y_1.Latest.Price, y_1.Compare.Price)} til $${latest_1}.`],
                    });
                }, c_2.slice(1, c_2.length))));
            }
        })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))))) : empty(), delay(() => {
            let drawSingle_1, elems_1;
            return append((x.Currencies.length > 0) ? ((drawSingle_1 = ((c_3) => createElement("span", {
                children: [`${c_3.Name} prisen er ${upDown(c_3.Compare.Price, c_3.Latest.Price)} omtrent $${priceDiff(c_3.Latest.Price, c_3.Compare.Price)} til $${formatCurrency(c_3.Latest.Price)} ${since(date, x.LatestTradingDay).toLocaleLowerCase()}.`],
            })), singleton_1(createElement("p", createObj(ofArray([["style", {}], (elems_1 = toList(delay(() => {
                const matchValue_2 = x.Currencies;
                if (!equalsWith(equals, matchValue_2, defaultOf()) && (matchValue_2.length === 1)) {
                    return singleton_1(drawSingle_1(item(0, matchValue_2)));
                }
                else {
                    const c_5 = matchValue_2;
                    return append(singleton_1(drawSingle_1(item(0, c_5))), delay(() => mapIndexed((i, y_3) => {
                        const extra = (i === 0) ? " i samme periode" : "";
                        return createElement("span", {
                            children: [` ${y_3.Name} er ${upDown(y_3.Compare.Price, y_3.Latest.Price)} rundt $${priceDiff(y_3.Latest.Price, y_3.Compare.Price)} til $${formatCurrency(y_3.Latest.Price)}${extra}.`],
                        });
                    }, c_5.slice(1, c_5.length))));
                }
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))))) : empty(), delay(() => append((x.Markets.length > 0) ? map((market_1) => {
                const xs_3 = [drawMarketChanges(x.LatestTradingDay, market_1)];
                return react.createElement(react.Fragment, {}, ...xs_3);
            }, sortByDescending((market) => (market.Ticker === "OSE"), x.Markets, {
                Compare: comparePrimitives,
            })) : empty(), delay(() => append(map((n) => paragraphHolder(ofArray([paragraphTitle(n.Title), paragraphText(n.Desc)])), x.Notes), delay(() => {
                let elems_2;
                return (x.Dividends.length > 0) ? singleton_1(paragraphHolder(ofArray([paragraphTitle("Siste handelsdag inklusivt utbytte"), paragraphText(phraseDividends(x.Dividends)), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 10 + "px ",
                }], (elems_2 = map((d) => tickerChip(d.Ticker, d.Market), x.Dividends), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))]))) : empty();
            }))))));
        }));
    })))))))))), delay(() => {
        let value_30;
        return append(displayUpgrade ? singleton_1(section(singleton((value_30 = "\"Før børsåpning\" er tilgengelig for alle på mandager og tirsdager! aksje.io+ abonnementer kan lese \"Før børsåpning\" hver handelsdag.", createElement("p", {
            children: [value_30],
        }))))) : empty(), delay(() => append(singleton_1(createElement(AssetBanner, null)), delay(() => append(((x.Reports.length > 0) ? true : (x.MarketUpdates.length > 0)) ? singleton_1(section(toList(delay(() => concat(map((n_1) => map((u) => {
            let elems_3;
            return paragraphHolder(ofArray([paragraphTitle(u.Title), paragraphText(u.Content), createElement("div", createObj(ofArray([["style", {}], (elems_3 = [tickerChip(n_1.Ticker, n_1.Market)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))]));
        }, n_1.Updates), x.MarketUpdates)))))) : empty(), delay(() => append((isAuthenticated) ? singleton_1(createElement(Feedback, {
            preOpenDate: date,
        })) : empty(), delay(() => singleton_1(linkToAll())))))))));
    })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
}

function drawRequireSub() {
    let value, value_1, elems_2, elems, elems_1;
    return section(ofArray([sectionTitle("Du har ikke tilgang"), (value = "Denne \"Før børsåpning\"-artikkelen krever at du er innlogget med en aksje.io bruker med gyldig aksje.io+ abonnement.", createElement("p", {
        children: [value],
    })), (value_1 = "Logg inn på aksje.io gjennom vår mobilapp og oppgrader til et aksje.io+ abonnement for å få tilgang til denne artikkelen og alle andre \"Før børsåpning\"-artikler", createElement("p", {
        children: [value_1],
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: 10 + "px ",
        marginTop: 10,
    }], (elems_2 = [createElement("a", createObj(ofArray([["style", {
        lineHeight: 0 + "px",
    }], ["href", "https://apps.apple.com/app/aksje-io/id6448765436"], ["aria-label", "Last ned aksje.io fra Apple App Store"], (elems = [createElement("img", {
        src: "/images/app_store_download.svg",
        target: "_blank",
        alt: "Lenke til aksje.io på Apple App Store",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("a", createObj(ofArray([["style", {
        lineHeight: 0 + "px",
    }], ["href", "https://play.google.com/store/apps/details?id=io.aksje.app&pli=1"], ["target", "_blank"], (elems_1 = [createElement("img", {
        style: {
            height: 50,
        },
        src: "https://play.google.com/intl/en_us/badges/static/images/badges/no_badge_web_generic.png",
        alt: "Last ned fra Google Play Store",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), linkToAll()]));
}

function drawNotFound() {
    let value;
    return section(ofArray([sectionTitle("Fant ikke \"Før børsåpning\"-artikkelen"), (value = "Vi fant ikke artikkelen du leter etter. Sjekk at nettadressen er korrekt. Om du limte inn nettadressen selv, sjekk at du fikk med hele lenken.", createElement("p", {
        children: [value],
    })), linkToAll()]));
}

export function PreOpenSummary(preOpenSummaryInputProps) {
    let elems;
    const date = preOpenSummaryInputProps.date;
    const patternInput = useFeliz_React__React_useState_Static_1505(new PreOpenStatus(0, []));
    const status = patternInput[0];
    const setStatus = patternInput[1];
    let displayUpgrade;
    try {
        const d = dayOfWeek(parse(date)) | 0;
        displayUpgrade = ((d === 1) ? true : (d === 2));
    }
    catch (matchValue) {
        displayUpgrade = false;
    }
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(PreOpenContent_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/pre-open/${date}`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(PreOpenContent_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 0) {
                    setStatus(new PreOpenStatus(1, [res.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    const err = res.fields[0];
                    let matchResult, y_2, y_3;
                    if (err.tag === 2) {
                        if ((err.fields[0].status) === 401) {
                            matchResult = 0;
                            y_2 = err.fields[0];
                        }
                        else if ((err.fields[0].status) === 404) {
                            matchResult = 1;
                            y_3 = err.fields[0];
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0: {
                            setStatus(new PreOpenStatus(2, []));
                            return Promise.resolve();
                        }
                        case 1: {
                            setStatus(new PreOpenStatus(4, []));
                            return Promise.resolve();
                        }
                        default: {
                            setStatus(new PreOpenStatus(3, ["Noe gikk galt. Vennligst prøv igjen senere."]));
                            return Promise.resolve();
                        }
                    }
                }
            });
        }));
        pr_1.then();
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        padding: 1 + "vw",
    }], (elems = toList(delay(() => ((status.tag === 1) ? singleton_1(drawPreOpen(displayUpgrade, date, status.fields[0])) : ((status.tag === 2) ? singleton_1(drawRequireSub()) : ((status.tag === 3) ? singleton_1(section(singleton(Alert_errorAlert(status.fields[0], () => {
    })))) : ((status.tag === 4) ? singleton_1(drawNotFound()) : singleton_1(section(singleton(LoadingIndicator_skeleton(singleton(["height", 50 + "vh"]))))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

